export default __webpack_public_path__ + "static/AppCV6-fa257dfae6dcfe874900c11594cf28ac.png";